import type { InputProps } from './input.props'
import { useStyles } from './input.web.styles'

export const Input = (props: InputProps) => {
  const {
    required: isRequired = false,
    isError = false,
    startContent,
    endContent,
    containerClass = '',
    disabled,
    id,
    dataRecurly,
    ...inputProps
  } = props

  const styles = useStyles({ isError, disabled })

  return (
    <div
      data-testid='inputWrapper'
      className={`${styles.inputWrapper} ${isError ? styles.error : ''} ${containerClass}`}
    >
      {startContent && startContent}

      <input
        {...inputProps}
        id={id}
        disabled={disabled}
        data-recurly={dataRecurly}
        data-testid='inputField'
        className={styles.input}
        aria-required={isRequired}
        aria-invalid={isError}
      />

      {endContent && endContent}
    </div>
  )
}
